import { type FC, useId } from 'react';
import type { MeetingTitleFieldProps } from '../../types';

const MeetingTitleField: FC<MeetingTitleFieldProps> = ({ value, onChange, error }) => {
  const meetingTitleId = useId();

  return (
    <div className="schedule-meeting-modal__form-group">
      <div className="schedule-meeting-modal__input-group">
        <label className="schedule-meeting-modal__input-label" htmlFor={meetingTitleId}>
          Meeting title *
        </label>
        <input
          type="text"
          id={meetingTitleId}
          value={value}
          className="schedule-meeting-modal__input-field"
          placeholder="Enter meeting title"
          maxLength={100}
          onChange={(e) => onChange(e.target.value)}
        />
        {error && <span className="schedule-meeting-modal__error-message">{error}</span>}
      </div>
    </div>
  );
};

export default MeetingTitleField;
